module.exports = __webpack_public_path__ + "img/vegetable-chicories-350x184.aaa276bb.jpg";